<template>
  <div class="orderadd">
    <div class="tip boxStyle">
      <p>温馨提示：</p>
      <p><span style="color:red">信息必须真实无误</span>，否则进校时无法通过身份核验。预约成功后，<span style="color:red">携带本人身份证</span>从预约参观通道核验通行，请您按照预约日期<span style="color:red">09:00</span>至<span style="color:red">16:00</span>前往参观游览。北京理工大学期待您的到来!</p>
     
    </div>
    <van-form ref="form" @submit="onSubmit">
      <div class="optionItem boxStyle">
        <van-field
          v-model="personInfo.campusName"
          name="reason"
          label="校区"
          readonly
          required
          clickable
          is-link
          @click="zoneClick"
          placeholder="请选择校区(必选项)"
          :rules="[{ required: true }]"
        />
        <van-field
          v-model="personInfo.name"
          name="personname"
          label="姓名"
          required
          placeholder="请输入姓名(必填项)"
          :rules="[{ required: true}]"
        />
        
        <van-field
          v-model="personInfo.cardno"
          name="cardno"
          label="证件号码"
          required
          placeholder="请输入证件号码(必填项)"
          :rules="[{ required: true}, {pattern: idPattern, message: '请输入正确的证件号码'}]"
        />
        <van-field
          v-model="personInfo.phone"
          name="phone"
          label="联系方式"
          required
          placeholder="请输入联系方式(必填项)"
          :rules="[{ required: true}, {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的联系方式'}]"
        />
        <van-field
          name="plate"
          v-model="personInfo.plate"
          label="车牌号码"
          :readonly="plateKeyStatus"
          :clickable="plateKeyStatus"
          @click.prevent="plateClick(null)"
          :placeholder="`请${plateKeyStatus ? '点击' : ''}输入车牌号码(非必填项)`"
          :rules="[{required: false, validator:plateValidator, message: '请输入正确的车牌号码'}]"
        >
        <template #button>
          <van-button size="small" @click.prevent.stop="plateKeyStatus = !plateKeyStatus">
            {{ !plateKeyStatus ? '车牌键盘' : '手动输入' }}
            
          </van-button>
        </template>
        </van-field>
        <van-field
          readonly
          clickable
          required
          is-link
          name="beginTime"
          :value="personInfo.beginTime"
          label="预约日期"
          placeholder="请选择预约日期"
          @click="beginTimePicker = true"
          :rules="[{ required: true}]"
        />
        <van-field
          readonly
          required
          name="endTime"
          value="09:00~16:00"
          label="预约时间"
        />
        <!-- :rules="[{ required: false }, {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的联系方式'}]" -->
        
       </div>
       <!-- <div class="tip boxStyle" v-if="peerPersons.length" style="margin-top: 20px">
        <p tyle="font-size: 13px; color: #aaa">温馨提示：</p>
        <p style="font-size: 12px; color: #aaa"><span style="color:red">同行人</span> 姓名与身份证号必须真实无误，否则进校时无法通过身份核验。预约成功后，预约人和同行人均需使用居民二代身份证原件入校！</p>
      
      </div> -->
      
       <div class="optionItem boxStyle" v-for="(item, index) in peerPersons" :key="index">
        <h3>
          <span>{{ '同行人' + (index + 1)}}</span>
          <van-icon  @click="delPerson(index)" name="delete-o" size="0.4rem" />
        </h3>
        <van-field
          v-model="item.name"
          name="name"
          label="姓名"
          required
          placeholder="请输入姓名(必填项)"
          :rules="[{ required: true}]"
        >
       
        </van-field>
        
        <van-field
          v-model="item.cardno"
          name="cardno"
          label="证件号码"
          required
          placeholder="请输入证件号码(必填项)"
          :rules="[{ required: true}, {pattern: idPattern, message: '请输入正确的证件号码'}]"
        />
        <van-field
          v-model="item.phone"
          name="phone"
          label="联系方式"
          required
          placeholder="请输入联系方式(必填项)"
          :rules="[{ required: true}, {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的联系方式'}]"
        />
        <!-- :rules="[{ required: false }, {pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/, message: '请输入正确的联系方式'}]" -->
        
        <van-field
          name="plate"
          v-model="item.plate"
          label="车牌号码"
          :readonly="plateKeyStatus"
          :clickable="plateKeyStatus"
          @click.prevent="plateClick(index)"
          :placeholder="`请${plateKeyStatus ? '点击' : ''}输入车牌号码(非必填项)`"
          :rules="[{required: false, validator:plateValidator, message: '请输入正确的车牌号码'}]"
        >
        <template #button>
          <van-button size="small" @click.prevent.stop="plateKeyStatus = !plateKeyStatus">
            {{ !plateKeyStatus ? '车牌键盘' : '手动输入' }}
            
          </van-button>
        </template>
        </van-field>
       </div>
       <div  class="btn" v-if="peerPersons.length < guestLimit">
        <van-button color="#13c5d0" block @click.prevent="peerPersons.push({})"><span style="color: #fff;">添加同行人</span></van-button>
      </div>
      <div  class="btn">
        <van-button  block  type="info" >保存</van-button>
      </div>
    </van-form>
    
    <van-popup v-model="beginTimePicker" :close-on-click-overlay="false" position="bottom">
        <!-- :max-date="maxDate" -->
      <van-datetime-picker
        v-model="defaultTime.beginTime"
        type="date"
        :max-date="maxDate"
        :min-date="minDate"
        @confirm="onConfirm($event, 'beginTime')"
        @cancel="beginTimePicker = false"
      />
    </van-popup>
    <van-popup :close-on-click-overlay="false" v-model="endTimePicker" position="bottom" >
      <van-datetime-picker
        :value="defaultTime.endTime"
        type="date"
        key="end"
        @confirm="onConfirm($event,'endTime')"
        @cancel="endTimePicker = false"
      />
    </van-popup>
    <van-popup v-model="zoneStatus" :close-on-click-overlay="false"  position="bottom">
      <van-picker
        title="校区"
        show-toolbar
        :columns="zoneList"
        @confirm="zoneConfirm"
        @cancel="zoneStatus = false"
        valueKey="zoneName"
      />
    </van-popup>
    <van-popup v-model="plateStatus" :closeable="true" :safe-area-inset-bottom="true" :close-on-click-overlay="false" :close-on-popstate="true" position="bottom" round :style="{ height: '50%' }">
    
    <KeyBord @sendCarNumber="sendCarNumber" />
  </van-popup>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import KeyBord from './keyboards'
import { savePerson, getCampus, getCfg } from '@/api/user'
import { getGuestTypeDetail } from '@/api/order'
import { getCampusId } from '../../utils/auth'
export default {
  components: { KeyBord },
  data () {
    return {
      guestLimit: 10,
      plateStatus: false,
      plateKeyStatus: false, // false是手动输入 true 是车牌键盘输入
      plateIndex: null,
      zoneStatus: false,
      maxDate: new Date(new Date().getTime() + (24 * 60 * 60 * 1000 * 2 )) ,
      minDate: new Date(new Date().getTime()),
      personInfo: {},
      peerPersons: [],
      zoneList: [],
      idPattern: /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[0-9Xx]$/,
      defaultTime: {
        beginTime: new Date(),
        endTime: new Date()
      },
      beginTimePicker: false,
      endTimePicker: false,
    }
  },
  created () {
    
    // this.personInfo.beginTime = dayjs().format('YYYY-MM-DD')
    // this.personInfo.endTime = dayjs().format('YYYY-MM-DD')
    this.getCampusList()
    this.getGuestTypeDetail()
  },
  methods: {
    // 获取游客的业务类型详情
    getGuestTypeDetail () {
      getGuestTypeDetail({status: 1}).then(res => {
        if(res.code === 0) {
          if (res.data) {
            
            this.guestLimit = res.data?.guestLimit || 10
            
            const guestForwardDays = 3;
            const dateLimit = Number(res.data?.dateLimit ?? 0);

            this.minDate = dayjs().add(guestForwardDays, 'day').startOf('day').toDate();

            if (dateLimit === -1) {
              this.maxDate = dayjs(this.minDate).add(10, 'year').endOf('day').toDate();
            } else if (dateLimit === 0) {
              this.maxDate = dayjs(this.minDate).endOf('day').toDate();
              this.defaultTime.beginTime = this.minDate;
              this.personInfo.beginTime = dayjs(this.minDate).format('YYYY-MM-DD');
            } else {
              this.maxDate = dayjs(this.minDate).add(dateLimit - 1, 'day').endOf('day').toDate();
            }



            // let guestForwardDays = 3 // 提前三天预约
            // this.minDate = new Date(new Date().getTime() + (24 * 60 * 60 * 1000 * guestForwardDays))
            
            // if (res.data?.dateLimit == -1) {
            //   // 十年
            //   this.maxDate = new Date(new Date().getTime() + (24 * 60 * 60 * 1000 * 365 * 10))
            // } else if (res.data?.dateLimit == 0) {
            //   // 当天
            //   this.maxDate = new Date(new Date().getTime() + (24 * 60 * 60 * 1000 * guestForwardDays))
            //   this.defaultTime.beginTime = this.maxDate
            //   this.personInfo.beginTime = dayjs(this.maxDate).format('YYYY-MM-DD')
            // } else if (res.data?.dateLimit > 0) {
            //   // 自定义天数
            //   this.maxDate = new Date(new Date().getTime() + (24 * 60 * 60 * 1000 * ((res.data?.dateLimit || 0) + guestForwardDays)))
            // }


          }
        }else{
        this.$toast.fail(res.msg)
        }
      }).catch(err => {
        this.$toast('请求失败' + err)
      })
    },
    plateClick (index) {
      console.log(index);
      if (!this.plateKeyStatus) return
      this.plateIndex = index
      this.plateStatus = true
    },
    sendCarNumber (plate) {
      if(plate.includes('军')) {
        plate = plate.replace('军', '')
      }
      if (this.plateIndex != null) {
        this.$set(this.peerPersons[this.plateIndex], 'plate', plate)
      } else {

        this.$set(this.personInfo, 'plate', plate)
      }
      // this.personInfo.plate = plate
      this.plateStatus = false
    },
    // 车牌号的校验
    plateValidator (value) {
      const carNumberReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领军a-zA-Z]([A-Z]|[a-z])([A-Z0-9]|[a-z0-9]){4,5}([A-Z0-9挂军警港澳]|[a-z0-9挂军警港澳])$/
      if (value) {
        // let arrs = ['使','领','军','警','港','澳']
        // arrs.forEach
        if(value.includes('使') || value.includes('领') || value.includes('军') || value.includes('警') || value.includes('港') || value.includes('澳')) {
          return true
        } else {

          return carNumberReg.test(value)
        }
      }
    },
    getSysCfg () {
      getCfg().then(res => {
        if(res.code === 0) {
          if (res.data) {
            let guestForwardDays = res.data.guestForwardDays || 0
            this.minDate =  new Date(new Date().getTime() + (24 * 60 * 60 * 1000  * guestForwardDays ))
            let guestReqDays = res.data.guestReqDays || 30
            if (guestReqDays > 1) {
              guestReqDays = guestReqDays - 1
            } else if (guestReqDays == 1) {
              guestReqDays = 0
            }
            this.maxDate = new Date(new Date(this.minDate).getTime() + (24 * 60 * 60 * 1000  * guestReqDays ))
           
          }
        }else{
        this.$toast.fail(res.msg)
        }
      }).catch(err => {
        this.$toast('请求失败' + err)
      })
    },
    // 选择校区
    zoneClick () {
      if (getCampusId()) return
      this.zoneStatus = true
    },
    zoneConfirm (e) {
      if (e) {
        this.personInfo.campusName = e.zoneName
        this.personInfo.campusId = e.zoneId
      }
      this.zoneStatus = false
    },
    // 获取校区
    getCampusList () {
      getCampus().then(res => {
        if (res.code == 0) {
          this.zoneList = res.data || []
          let campusId = getCampusId()
          if (campusId) {
            let _findCampus = this.zoneList.find(item => item.zoneId == campusId)
            if (_findCampus) {
              this.personInfo.campusName = _findCampus.zoneName
              this.personInfo.campusId = _findCampus.zoneId
            }
          } else if(this.zoneList.length == 1) {
            this.personInfo.campusName = this.zoneList[0].zoneName
            this.personInfo.campusId = this.zoneList[0].zoneId
          }
        } else {
          this.$toast.fail(res.message)
        }
      }).catch(() => {
        this.$toast.fail('获取校区失败:请求失败')
      })
    },
    onSubmit() {
      let hasPlate = false
      let _params = {
        ...this.personInfo,
        cardno: this.personInfo.cardno.toLocaleUpperCase(),
        beginTime: this.personInfo.beginTime + ' 09:00:00',
        endTime: this.personInfo.beginTime + ' 16:00:00',
        // campusId: this.$store.state.campusId,
        baseOrderType: 99,
        otherVisits: this.peerPersons.filter(item => item.cardno).map(item => {
          return {
            ...item,
            cardno: item.cardno ? item.cardno.toLocaleUpperCase() : '',
            plate: item.plate ? item.plate.replace(/\s*/g,"").toLocaleUpperCase() : ''
          }
        })
      }
      // 如果有车牌号将车牌号码去除空格, 转换为大写 如果存在车牌号码提示
      if (_params.plate) {
        _params.plate = _params.plate.replace(/\s*/g,"").toLocaleUpperCase()
        hasPlate = true
      }
      if (_params.otherVisits.some(item => item.plate)) {
        hasPlate = true
      }
      
      // console.log(_params, '_params');
      // 'plate' in this.personInfo && (_params.plate = this.personInfo.plate)
      savePerson({..._params}).then(res => {
        if(res.code === 0) {
          this.$toast.success('提交成功')
          let _this = this
          if (hasPlate && res.plateInfo) {
            this.$dialog.alert({
              // title: '友情提示',
              message: res.plateInfo,
            }).then(() => {
              // on close
              _this.$router.go(-1)
            });
          } else {
            setTimeout(() => {
              _this.$router.go(-1)
            }, 1500)
          }
         
        }else{
          this.$toast.fail(res.msg)
        }

      }).catch(err => {
        this.$toast('请求失败:' + err)
      })
    },
    onConfirm (val, time) {
      this[time + 'Picker'] = false
      this.personInfo[time] = dayjs(val).format('YYYY-MM-DD')
      // if (time == 'endTime') {
      //   if (new Date(val).getTime() < new Date(this.personInfo.beginTime).getTime()) {
      //     this.$toast('结束时间不能小于起始时间')
      //     this.personInfo.endTime = ''
      //   }
      // }
      if (time == 'beginTime') {
        this.personInfo.endTime = dayjs(val).format('YYYY-MM-DD')
      }
    },
    // 删除同行人
    delPerson (index) {
      this.$dialog.confirm({
        title: '删除',
        message: '确定要删除这条数据吗?',
      })
      .then(() => {
        this.peerPersons.splice(index, 1)
      })
    },
  }
}
</script>

<style scoped lang="less">
.boxStyle {
  
  border-radius: 8px;
  box-shadow: 0 0 13px 4px rgba(156, 156, 156, 0.223);
}
.orderadd {
  height: 100vh;
  overflow-y: auto;
  background-color: #fcfffc;
  // background-color: #f1f8fd;
  padding: 13px 15px;
}
.optionItem {
  background-color: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-top: 10px;
  h3 {
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content:space-between;
    margin-bottom: 10px;
    padding: 0 8px
  }
  
}
.btn {
    clear: both;
    margin-top: 20px;
    overflow: hidden;
    border-radius: 8px;
    &:last-child {
      margin-bottom: 20px;
    }
  }
.tip {
  background-color: #fff;
  border-left: 4px solid #34b471;
  padding: 10px;
  p {
    color: #676767;
    &:first-child {
      font-weight: bold;
    }
    &:last-child {
      text-indent: 14px;
      margin-top: 5px;
    }
  }
}
</style>